module.exports = __webpack_public_path__ + "assets/HKNova-ExtraBold.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-ExtraBold.eot
// module id = 117
// module chunks = 0